export enum ShippingReference {
    GET_FROM_FILE = 'GET_FROM_FILE',
    NO_SHIPPING = 'NO_SHIPPING',
    SET_PROVIDED_ADDRESS = 'SET_PROVIDED_ADDRESS'
}
